export default function() {
  var size = 0;
  this.each(function() { ++size; });
  return size;
}



// WEBPACK FOOTER //
// C:/Dropbox/www/amcharts4dev/node_modules/d3-selection/src/selection/size.js